var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 354,
    height: 96,
    viewBox: "0 0 354 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7391 9.67182L10.4456 3.50002L20 3.50004L346.25 3.50061L349.75 3.50062L349.75 7.00061L349.75 88.4471L349.75 91.9471L346.25 91.9471L116.25 91.9471L114.968 91.9471L113.989 91.1189L17.7391 9.67182Z",
    fill: "url(#paint0_linear_29_359)",
    stroke: "black",
    strokeWidth: 7
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_29_359",
    x1: 346.25,
    y1: 7,
    x2: 346,
    y2: 88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBC11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#FEBC11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDF8C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/Right.8ab5216a96f55dff83dfda522fdc078f.svg";
export { ForwardRef as ReactComponent };